document.addEventListener('click', function(e) {
  const banner = e.target.closest('.video-banner-image');
  if (banner) {
    const parent = banner.closest('.video-section--container');
    if (parent) {
      parent.classList.add('playvideo');

      const video = parent.querySelector('video');
      if (video) {
        video.play().catch(err => {
          console.warn('Video playback prevented:', err);
        });
      }
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('splitPopup');
  const cookieName = 'split_popup_seen';
  const days = 7;

  function setCookie(name, value, daysToStore) {
    const d = new Date();
    d.setTime(d.getTime() + daysToStore * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
  }

  function getCookie(name) {
    const cname = name + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim();
      if (c.indexOf(cname) === 0) {
        return c.substring(cname.length, c.length);
      }
    }
    return '';
  }

  if (!getCookie(cookieName) && popup) {
    popup.style.display = 'flex';
  }

  document.querySelectorAll('.split').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const href = this.getAttribute('href');

      if (popup) {
        popup.style.display = 'none';
      }
      setCookie(cookieName, 'true', days);

      if (this.classList.contains('right')) {
        const updateLogoLink = () => {
          const headerLogo = document.querySelector('.header--inner .logolink');
          if (headerLogo) {
            headerLogo.href = 'https://www.thermosoft.com/pages/professional';
          } else {
            setTimeout(updateLogoLink, 200);
          }
        };
        updateLogoLink();
        localStorage.setItem('professional', 'professional_page');
      }

      setTimeout(() => {
        if (href && href !== '#') {
          window.location.href = href;
        }
      }, 200);
    });
  });

  if (localStorage.getItem('professional')) {
    const headerLogo = document.querySelector('.header--inner .logolink');
    if (headerLogo) {
      headerLogo.setAttribute('href', '/pages/professional');
    }
  }
});

function updateNodesToSharedHeight(nodes, propertyName) {
  if (!nodes.length) return;

  nodes.forEach(node => {
    node.style[propertyName] = '';
  });

  let maxHeight = 0;
  nodes.forEach(node => {
    const height = Math.ceil(node.getBoundingClientRect().height);
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  nodes.forEach(node => {
    node.style[propertyName] = maxHeight ? maxHeight + 'px' : '';
  });
}

function setEqualHeights() {
  const productInfoBlocks = Array.from(document.querySelectorAll('.product_info'));

  if (productInfoBlocks.length) {
    const productInfoColumns = productInfoBlocks.map(block => Array.from(block.querySelectorAll('.product_info_column')));
    const rowCount = productInfoColumns.reduce((max, columns) => Math.max(max, columns.length), 0);

    productInfoColumns.forEach(columns => {
      columns.forEach(column => {
        column.style.minHeight = '';
      });
    });

    for (let i = 0; i < rowCount; i++) {
      const rowColumns = productInfoColumns.map(columns => columns[i]).filter(Boolean);
      updateNodesToSharedHeight(rowColumns, 'minHeight');
    }
  }

  updateNodesToSharedHeight(Array.from(document.querySelectorAll('.heating-system_content .h6')), 'minHeight');
  updateNodesToSharedHeight(Array.from(document.querySelectorAll('.heating-systems-content .title')), 'height');
}

let equalHeightsFrame = null;
function scheduleEqualHeights() {
  if (equalHeightsFrame) {
    window.cancelAnimationFrame(equalHeightsFrame);
  }

  equalHeightsFrame = window.requestAnimationFrame(() => {
    equalHeightsFrame = null;
    setEqualHeights();
  });
}

let equalizeHeatingContentFrame = null;
function scheduleHeatingContentEqualization() {
  if (equalizeHeatingContentFrame) {
    window.cancelAnimationFrame(equalizeHeatingContentFrame);
  }

  equalizeHeatingContentFrame = window.requestAnimationFrame(() => {
    equalizeHeatingContentFrame = null;
    equalizeHeatingContent();
  });
}

document.addEventListener('DOMContentLoaded', function() {
  scheduleEqualHeights();
  scheduleHeatingContentEqualization();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleEqualHeights).catch(() => {});
    document.fonts.ready.then(scheduleHeatingContentEqualization).catch(() => {});
  }

  let equalHeightsResizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(equalHeightsResizeTimer);
    equalHeightsResizeTimer = setTimeout(() => {
      scheduleEqualHeights();
      scheduleHeatingContentEqualization();
    }, 150);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.logo-list--inner.swipe-on-mobile');
  if (!slider) return;
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  if (!slider.classList.contains('is-cloned')) {
    slider.innerHTML += slider.innerHTML;
    slider.classList.add('is-cloned');
  }

  const speed = 60;
  let rafId = null;
  let isActive = true;
  let lastTimestamp = 0;

  function step(timestamp) {
    if (!isActive) {
      rafId = null;
      lastTimestamp = 0;
      return;
    }

    if (!lastTimestamp) {
      lastTimestamp = timestamp;
    }

    const delta = timestamp - lastTimestamp;
    lastTimestamp = timestamp;
    const maxScroll = slider.scrollWidth / 2;

    slider.scrollLeft += (speed * delta) / 1000;

    if (slider.scrollLeft >= maxScroll) {
      slider.scrollLeft = 0;
    }

    rafId = window.requestAnimationFrame(step);
  }

  function startSlider() {
    if (rafId || !isActive) return;
    rafId = window.requestAnimationFrame(step);
  }

  function stopSlider() {
    if (!rafId) return;
    window.cancelAnimationFrame(rafId);
    rafId = null;
    lastTimestamp = 0;
  }

  function updateSliderState(shouldRun) {
    isActive = shouldRun;

    if (isActive) {
      startSlider();
    } else {
      stopSlider();
    }
  }

  if (typeof IntersectionObserver === 'function') {
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      updateSliderState(Boolean(entry && entry.isIntersecting) && !document.hidden);
    });

    observer.observe(slider);
  } else {
    startSlider();
  }

  document.addEventListener('visibilitychange', function() {
    updateSliderState(!document.hidden);
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.heating-systems-inner');

  cards.forEach(card => {
    const content = card.querySelector('.heating-systems-content .rte');
    const btn = card.querySelector('.heating-systems-button .read-more-btn');

    if (!btn) return;

    if (!content || !content.textContent.trim()) {
      btn.style.opacity = '0';
      btn.style.visibility = 'hidden';
      return;
    }

    btn.addEventListener('click', function() {
      content.classList.toggle('expanded');

      btn.textContent = content.classList.contains('expanded') ? 'Read less' : 'Read more';
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  let touchLink = null;
  let touchStartX = 0;
  let touchStartY = 0;

  document.addEventListener('touchstart', function(event) {
    const link = event.target.closest('.heating-systems-button .shop_button');
    if (!link) {
      touchLink = null;
      return;
    }
    touchLink = link;
    touchStartX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : 0;
    touchStartY = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientY : 0;
  }, { passive: true, capture: true });

  document.addEventListener('touchend', function(event) {
    if (!touchLink) {
      return;
    }

    const endTouch = event.changedTouches && event.changedTouches[0];
    const endX = endTouch ? endTouch.clientX : touchStartX;
    const endY = endTouch ? endTouch.clientY : touchStartY;
    const moved = Math.abs(endX - touchStartX) > 10 || Math.abs(endY - touchStartY) > 10;
    const activeLink = event.target.closest('.heating-systems-button .shop_button');
    const href = touchLink.getAttribute('href');

    if (!moved && activeLink === touchLink && href) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(href);
    }

    touchLink = null;
  }, { passive: false, capture: true });
});

(function() {
  function setupReadMore() {
    const sections = document.querySelectorAll('.rtm.rtm--readmore');
    if (!sections.length) return;

    sections.forEach(function(root) {
      const content = root.querySelector('.rtm__content');
      const btn = root.querySelector('.rtm__toggle');
      const more = root.querySelector('.rtm__more');
      const less = root.querySelector('.rtm__less');
      if (!content || !btn) return;

      // Remember what the user actually chose, so a resize-triggered
      // re-run doesn't silently collapse content they expanded.
      const wasExpanded = content.classList.contains('is-expanded');

      let lineHeight = parseFloat(getComputedStyle(content).lineHeight);
      if (Number.isNaN(lineHeight)) {
        const fontSize = parseFloat(getComputedStyle(content).fontSize) || 16;
        lineHeight = fontSize * 1.2;
      }
      const maxHeight = lineHeight * 5;

      content.classList.remove('is-collapsed');
      content.classList.remove('is-expanded');
      const fullHeight = content.scrollHeight;

      if (fullHeight <= maxHeight) {
        btn.style.display = 'none';
        more.hidden = true;
        less.hidden = true;
        content.classList.remove('is-expanded');
        content.classList.remove('is-collapsed');
      } else {
        btn.style.display = 'inline-flex';

        // Restore the user's previous choice instead of forcing collapsed.
        if (wasExpanded) {
          content.classList.add('is-expanded');
          content.classList.remove('is-collapsed');
          more.hidden = true;
          less.hidden = false;
        } else {
          content.classList.add('is-collapsed');
          content.classList.remove('is-expanded');
          more.hidden = false;
          less.hidden = true;
        }
      }

      if (btn.dataset.rtmInitialized === 'true') {
        return;
      }
      btn.dataset.rtmInitialized = 'true';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const collapsed = content.classList.contains('is-collapsed');
        if (collapsed) {
          content.classList.remove('is-collapsed');
          content.classList.add('is-expanded');
          more.hidden = true;
          less.hidden = false;
        } else {
          content.classList.remove('is-expanded');
          content.classList.add('is-collapsed');
          more.hidden = false;
          less.hidden = true;
        }
      });
    });
  }

  // Only re-run on resize when the width actually changes (orientation
  // change, window resize, breakpoint change). Mobile browsers fire
  // 'resize' when the address bar shows/hides during scroll, which only
  // changes height — that should NOT re-trigger the read-more logic.
  let lastWidth = window.innerWidth;
  let resizeDebounce = null;

  document.addEventListener('DOMContentLoaded', setupReadMore);

  window.addEventListener('resize', function() {
    if (window.innerWidth === lastWidth) {
      return;
    }
    lastWidth = window.innerWidth;

    if (resizeDebounce) {
      window.clearTimeout(resizeDebounce);
    }
    resizeDebounce = window.setTimeout(setupReadMore, 150);
  });
})();

function equalizeHeatingContent() {
  const contents = Array.from(document.querySelectorAll('.heating-systems-content'));

  if (!contents.length) return;

  updateNodesToSharedHeight(contents, 'height');
}

document.addEventListener('DOMContentLoaded', function() {
  const toggle = document.querySelector('.compare-toggle');
  const counter = document.querySelector('.compare-counter');

  if (!toggle || !counter) return;

  function updateCompareToggle() {
    const count = parseInt(counter.textContent.trim(), 10) || 0;
    toggle.style.display = count === 0 ? 'none' : '';
  }

  updateCompareToggle();

  const observer = new MutationObserver(updateCompareToggle);
  observer.observe(counter, {
    childList: true,
    characterData: true,
    subtree: true
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const btnCartDrawer = document.getElementById('cart-drawer-toggle-mobile');
  const btnHamburger = document.querySelector('.mobile-toggle');
  const mobileContactNumber = document.querySelector('.mobile-contact-number');
  const contactInfoBar = document.querySelector('.contact-info-bar');
  const searchBarIcon = document.querySelector('.thb-quick-search');
  const headerInner = document.querySelector('.header .header--inner');

  function setElementVisibility(element, displayValue) {
    if (!element) return;

    element.style.display = displayValue;
    element.style.contentVisibility = displayValue === 'none' ? 'hidden' : 'visible';
  }

  function iconBarFunction() {
    if (window.__thermoMobileIconBarHandled) {
      return;
    }

    function handleClick(selector, callback) {
      const element = document.querySelector(selector);
      if (!element) return;

      element.addEventListener('click', function(e) {
        e.preventDefault();
        callback();
      });
    }

    handleClick('.btn-menu-hamburger', function() {
      btnHamburger?.click();
      setElementVisibility(mobileContactNumber, 'none');
      setElementVisibility(contactInfoBar, 'flex');
      if (searchBarIcon) searchBarIcon.style.display = 'none';
    });

    handleClick('.btn-menu-quote', function() {
      window.location.href = '/pages/contact';
    });

    handleClick('.btn-menu-pros', function() {
      window.location.href = '/pages/professional';
    });

    handleClick('.btn-menu-cart', function() {
      btnCartDrawer?.click();
    });
  }

  const mediaQuery = window.matchMedia('(max-width: 430px)');

  function handleScreenChange(event) {
    if (!headerInner) return;

    if (event.matches) {
      if (headerInner.dataset.mobileMenuIconsInitialized !== 'true') {
        iconBarFunction();
        headerInner.dataset.mobileMenuIconsInitialized = 'true';
      }
      headerInner.classList.add('new-mobile-menu');
      headerInner.classList.remove('old-mobile-menu');

      setTimeout(() => {
        if (headerInner.classList.contains('new-mobile-menu')) {
          setElementVisibility(mobileContactNumber, 'flex');
          setElementVisibility(contactInfoBar, 'none');
          const closeButton = document.querySelector('.new-mobile-menu .close-menu');
          if (closeButton) {
            closeButton.onclick = function() {
              setElementVisibility(mobileContactNumber, 'flex');
              setElementVisibility(contactInfoBar, 'none');
            };
          }
        }
      }, 500);

    } else {
      headerInner.classList.remove('new-mobile-menu');
      headerInner.classList.add('old-mobile-menu');

      setTimeout(() => {
        if (headerInner.classList.contains('old-mobile-menu')) {
          setElementVisibility(mobileContactNumber, 'none');
          setElementVisibility(contactInfoBar, 'flex');
          if (searchBarIcon) searchBarIcon.style.display = 'flex';
          const closeButton = document.querySelector('.old-mobile-menu .close-menu');
          if (closeButton) {
            closeButton.onclick = function() {
              setElementVisibility(mobileContactNumber, 'none');
              setElementVisibility(contactInfoBar, 'flex');
              if (searchBarIcon) searchBarIcon.style.display = 'flex';
            };
          }
        }
      }, 500);
    }
  }

  handleScreenChange(mediaQuery);

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', handleScreenChange);
  } else if (typeof mediaQuery.addListener === 'function') {
    mediaQuery.addListener(handleScreenChange);
  }

  function getCartSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    }, {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    }, {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }, {
      id: 'cart-drawer-toggle-mobile',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  function renderCustomAddToCartContents(parsedState) {
    if (typeof Cart !== 'undefined' && document.getElementById('Cart')) {
      new Cart().renderContents(parsedState);
      return;
    }

    getCartSectionsToRender().forEach((section) => {
      const sectionRoot = document.getElementById(section.id);
      if (!sectionRoot || !parsedState.sections || !parsedState.sections[section.section]) {
        return;
      }

      const elementToReplace = sectionRoot.querySelector(section.selector) || sectionRoot;
      elementToReplace.innerHTML = getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    });
  }

  document.addEventListener('click', function(e) {
    const qtyButton = e.target.closest('.qty-btn1');
    if (qtyButton) {
      e.preventDefault();

      if (qtyButton.disabled) {
        return;
      }

      const wrapper = qtyButton.closest('.custom-quantity-selector');
      const qtyInput = wrapper?.querySelector('.qty-input1');
      if (!qtyInput || qtyInput.disabled) {
        return;
      }

      const min = parseInt(qtyInput.getAttribute('min'), 10) || 1;
      const currentValue = parseInt(qtyInput.value, 10) || min;
      const nextValue = qtyButton.classList.contains('qty-minus1')
        ? Math.max(min, currentValue - 1)
        : currentValue + 1;

      qtyInput.value = nextValue;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if (e.target.closest('.custom-add-to-cart')) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const button = e.target.closest('.custom-add-to-cart');
      const wrapper = button.closest('.custom-quantity-selector');
      const qtyInput = wrapper?.querySelector('.qty-input1');
      if (!qtyInput) return;

      const quantity = parseInt(qtyInput.value, 10);
      const variantId = button.dataset.variantId;

      button.classList.add('loading');
      button.disabled = true;

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        }
      };

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);
      formData.append('sections', getCartSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config).then(response => response.json()).then((response) => {
        if (response.status) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          button.classList.remove('loading');
          button.disabled = false;
          return;
        }

        renderCustomAddToCartContents(response);

        button.classList.remove('loading');
        button.disabled = false;

        const searchDrawer = document.getElementById('Search-Drawer');
        const cartDrawer = document.getElementById('Cart-Drawer');
        const hasMainCart = Boolean(document.getElementById('Cart'));

        if (searchDrawer?.classList.contains('active')) {
          searchDrawer.classList.remove('active');
        }

        if (hasMainCart) {
          document.body.classList.remove('open-cc');
          return;
        }

        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          return;
        }

        document.getElementById('cart-drawer-toggle-mobile')?.click();
        document.getElementById('cart-drawer-toggle')?.click();
      }).catch(error => {
        console.error('Error:', error);
        button.classList.remove('loading');
        button.disabled = false;
      });
    }
  });
});

const itemCount = document.querySelector('.thb-item-count');
const cartBadge = document.querySelector('.cart-count-badge');

document.addEventListener('click', function(e) {
  if (e.target.closest('.side-panel-close') || e.target.closest('.click-capture')) {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    setTimeout(() => {
      if (itemCount && cartBadge) {
        cartBadge.textContent = itemCount.textContent.trim();
      }
    }, 800);
  }
});
